module.exports = __webpack_public_path__ + "img/fitness3.5a90b3e4.png";